import { useLanguage } from "../context/LanguageContext";
import { useRefonte } from "../translations/refonte";

const PHOTO =
  "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxtYW5hZ2VyJTIwbGlzdGVuaW5nJTIwdGVhbSUyMG1lZXRpbmclMjBvZmZpY2UlMjBjYW5kaWR8ZW58MHx8fHwxNzg2NjIxMTk2fDA&ixlib=rb-4.1.0&q=85&w=2000";

// Respiration éditoriale entre deux grilles
const HumanQuoteSection = () => {
  const { language } = useLanguage();
  const q = useRefonte(language).humanQuote;

  return (
    <section className="relative isolate overflow-hidden" data-testid="human-quote-section">
      <img src={PHOTO} alt="" className="absolute inset-0 w-full h-full object-cover object-center" />
      <div className="absolute inset-0 bg-[linear-gradient(100deg,rgba(11,45,82,0.95)_0%,rgba(11,45,82,0.82)_45%,rgba(18,58,99,0.45)_100%)]" />
      <div className="wrap-cayus relative py-20 lg:py-24">
        <div className="max-w-2xl">
          <div className="rule-cobalt mb-6 !bg-[linear-gradient(90deg,#5EB3F6_0%,#CFE6FC_100%)]" />
          <p className="pull-quote text-2xl sm:text-3xl text-white leading-[1.35] mb-6">« {q.quote} »</p>
          <p className="mono-cayus text-[#9ECEFA]">{q.attribution}</p>
          <p className="text-base text-[#CFE6FC] mt-6 max-w-xl">{q.lead}</p>
        </div>
      </div>
    </section>
  );
};

export default HumanQuoteSection;
